<template>
    <!-- 资金安全  -->
    <sub-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg"
        :right-bg="rightBg" :right-bg2="rightBg2" :partition="[7, 5]" :imgpar="[2, 1]" />
</template>

<script>
import SubPage from '@/views/components/SubPage.vue'
export default {
    name: 'fund',
    components: {
        SubPage
    },
    data() {
        return {
            bg: "/img/pay/0--36.png",
            rightBg: "/img/pay/0--45.png",
            rightBg2: "/img/pay/0--44.png",
        }
    },
    computed: {
        title() {
            return this.$t('fund.title');
        },
        subtitle() {
            return this.$t('fund.subtitle');
        },
        description() {
            return [this.$t('fund.description1'),
            this.$t('fund.description2'),
            this.$t('fund.description3'),
            this.$t('fund.description4'),
            this.$t('fund.description5'),
            this.$t('fund.description6'),
            this.$t('fund.description7')];
        },
        buttonText() {
            return this.$t('common.buttonText');
        }
    }

}
</script>